import { render, staticRenderFns } from "./ExchangeRate.vue?vue&type=template&id=4a284836&"
import script from "./ExchangeRate.vue?vue&type=script&lang=js&"
export * from "./ExchangeRate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports